// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonStyles_buttonWrapper__1piQI","button":"buttonStyles_button__ELmCY","active":"buttonStyles_active__9UXOV"};